<template>
  <div>
    <div
      class="boundary-div"
      :style="{ height: domentDate.height, width: domentDate.width, left: domentDate.left }"
      v-if="visiable"
      ref="box"
    >
      <vue-draggable-resizable
        :w="width"
        :h="height"
        :x="x"
        :y="y"
        :z="9999"
        :min-width="380"
        :min-height="410"
        :parent="false"
        :grid="[1, 1]"
        class-name="dragging1"
        @dragging="onDrag"
        @resizing="onResize"
        :active="true"
        :prevent-deactivation="true"
        ref="drag"
      >
        <div style="width: 100%; height: 100%">
          <div class="bgzl-header">
            <div class="bgzl-title">
              <div class="title">背景资料</div>
            </div>
            <div>
              <a-button-group>
                <a-button class="btn-g" @click="modalClick('min')">
                  <a-icon type="minus" />
                </a-button>
                <a-button class="btn-g" v-if="modalMax == 0" @click="modalClick('max')">
                  <a-icon type="border" />
                </a-button>
                <a-button class="btn-g" @click="modalClick('close')">
                  <a-icon type="close" />
                </a-button>
              </a-button-group>
            </div>
          </div>
          <div style="height: 90%; overflow: auto">
            <a-tabs v-model="activeKey" hide-add type="editable-card" @change="changeTab" @edit="onEdit">
              <a-tab-pane
                v-for="data in paneList"
                :key="`${data.id}_${data.type}`"
                :tab="data.label"
                :closable="true"
                @change="getBgData(`${data.id}_${data.type}`)"
                style="overflow: auto"
              >
                <iframe :src="videoUrl" frameborder="0" v-if="data.type === 'video'" class="videoIframe" allowfullscreen="true" allowscriptaccess="always" allowtransparency="true"></iframe>
                <div v-else-if="data.type === 'form'">
                  <!-- {{ bgDatas }} -->
                  <!-- 商品编码 -->
                  <goods-code-list
                    :bgDatas="bgDatas"
                    v-if="bgDatas.length && data.billCode === 'qtbd_goods_table'"
                  ></goods-code-list>
                  <!-- 客户编码 -->
                  <custom-code-list
                    :bgDatas="bgDatas"
                    v-if="bgDatas.length && data.billCode === 'qtbd_customer_table'"
                  ></custom-code-list>
                  <!--金税盘图片-->
                  <div v-if="data.billCode === 'qtbd_uploadImg'">
                    <img :src="ossDomain + data.bgUrl" alt="" />
                  </div>
                  <!--最高开票限额申请表-->
                  <odiv-zgkpxesqb
                    :bgDatas="bgDatas"
                    v-if="bgDatas.length && data.billCode === 'odiv_zgkpxesqb'"
                  ></odiv-zgkpxesqb>
                  <!--销售合同-->
                  <odco-dzcpxshtfb
                    :bgDatas="bgDatas"
                    v-if="bgDatas.length && data.billCode === 'odco_dzcpxshtfb'"
                  ></odco-dzcpxshtfb>
                  <!--销售单-->
                  <odiv-xsd2 :bgDatas="bgDatas" v-if="bgDatas.length && data.billCode === 'odiv_xsd2'"></odiv-xsd2>
                  <!--出库单-->
                  <odiv-ckd :bgDatas="bgDatas" v-if="bgDatas.length && data.billCode === 'odiv_ckd'"></odiv-ckd>
                  <!--入库单-->
                  <odiv-rkd000-rkd
                    :bgDatas="bgDatas"
                    v-if="bgDatas.length && data.billCode === 'odiv_rkd000_rkd'"
                  ></odiv-rkd000-rkd>
                  <!--开具红字增值税专用发票通知单-->
                  <odiv-kjhrzzszzfptzs-xnsr
                    :bgDatas="bgDatas"
                    v-if="bgDatas.length && data.billCode === 'odiv_kjhrzzszzfptzs_xnsr'"
                  ></odiv-kjhrzzszzfptzs-xnsr>
                  <!--增值税专用发票-->
                  <odiv-zzszyfp
                    :bgDatas="bgDatas"
                    v-if="bgDatas.length && data.billCode === 'odiv_zzszyfp'"
                  ></odiv-zzszyfp>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </vue-draggable-resizable>
    </div>
    <div class="minTaskModal" v-if="minWind">
      <vue-draggable-resizable
        :w="320"
        :h="40"
        :x="minx"
        :y="miny"
        :min-width="320"
        :min-height="40"
        :grid="[1, 1]"
        class-name="dragging2"
        style="z-index: 9999"
        @dragging="onDrag"
        :resizable="false"
      >
        <div style="width: 100%; height: 100%">
          <div class="bgzl-header">
            <div class="bgzl-title">
              <!-- <img [src]="assetsUrl+'MainExecute.png'" /> -->
              <div class="title">背景资料</div>
            </div>
            <div>
              <a-button-group>
                <a-button class="btn-g" @click="minModal('max')">
                  <a-icon type="border" />
                </a-button>
                <a-button class="btn-g" @click="minModal('close')">
                  <a-icon type="close" />
                </a-button>
              </a-button-group>
            </div>
          </div>
        </div>
      </vue-draggable-resizable>
    </div>
  </div>
</template>
<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import { mapState } from 'vuex'
import { getBgTataData, parseParam, putBgTataData } from '@/utils/util.js'
import { environment } from '@/utils/oss.env'
import Urls from '@/utils/globel.js'
import Utils from '@/utils/oss.util.js'
import fileImg from '@/assets/file.png'
import goodsCodeList from '@/views/taskForm/goodsCodeList.vue'
import customCodeList from '@/views/taskForm/customCodeList.vue'
import odivZgkpxesqb from '@/views/taskForm/odiv-zgkpxesqb.vue'
import odcoDzcpxshtfb from '@/views/taskForm/odco-dzcpxshtfb.vue'
import odivXsd2 from '@/views/taskForm/odiv-xsd2.vue'
import odivCkd from '@/views/taskForm/odiv-ckd.vue'
import odivRkd000Rkd from '@/views/taskForm/odiv-rkd000-rkd.vue'
import odivKjhrzzszzfptzsXnsr from '@/views/taskForm/odiv-kjhrzzszzfptzs-xnsr.vue'
import odivZzszyfp from '@/views/taskForm/odiv-zzszyfp.vue'
export default {
  components: {
    VueDraggableResizable,
    goodsCodeList,
    customCodeList,
    odivZgkpxesqb,
    odcoDzcpxshtfb,
    odivXsd2,
    odivCkd,
    odivRkd000Rkd,
    odivKjhrzzszzfptzsXnsr,
    odivZzszyfp,
  },
  props: {
    visiable: {
      type: Boolean,
      default: false,
      required: false,
    },
    pane: {
      type: Object,
      default: () => {
        return {}
      },
    },
    videoId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      defaultWidth: 586,
      defaultHeight: 414,
      width: 586,
      height: 414,
      x: 0,
      y: 0,
      minx: 0,
      miny: 0,
      modalMax: 0,
      minWind: false,
      domentDate: { width: '', height: '', left: '0px' },
      firstRender: false,
      documentHeight: 0,
      activeKey: '',
      paneList: [],
      videoPlay: '',
      videoUrl: '',
      fileImg,
      bgDatas: [],
      ossDomain: environment.ossDomain,
    }
  },
  created() {
    this.firstRender = true
    const bodyHeight = document.body.clientHeight
    this.documentHeight = bodyHeight
    const newHeight = bodyHeight + this.height - 20
    const bodyWidth = document.body.clientWidth
    const width = this.width
    const newWidth = bodyWidth + width - 20
    this.domentDate.height = newHeight + 'px'
    this.domentDate.width = newWidth + 'px'
    const boxTop = bodyHeight - this.height
    this.y = boxTop
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.listenResize()
      })()
    }
  },
  computed: {
    ...mapState('practice', ['loginInfo']),
  },
  watch: {
    pane: {
      handler(val) {
        const index = this.paneList.findIndex((v) => v.id === val.id)
        if (index === -1) {
          if (val.videoId) {
            val.label = val.modName + '教学视频'
            val.type = 'video'
          } else if (val.id) {
            val.type = 'form'
            this.getBgData(val.id)
          }
          this.paneList.unshift(val)
        } else {
          this.getBgData(val.id)
        }
        this.activeKey = `${val.id}_${val.type}`
      },
    },
    videoId: {
      async handler(val) {
        if (val) {
          const key = this.activeKey.split('_')[0]
          if (getBgTataData(key) !== null) {
            this.videoUrl = getBgTataData(key)
          } else {
            const params = parseParam({
              videoId: val,
            })
            try {
              const result = await this.$http.post(`${Urls.getVideoParams}&${params}`)
              const veidUrl = Utils.videoUrl(val, result.data)
              console.log(veidUrl)
              if (veidUrl != null) {
                this.videoUrl = veidUrl
                putBgTataData(key, veidUrl)
                this.reData()
              }
            } catch (error) {
              this.$message.error({
                title: '提示',
                content: '获取视频参数错误',
              })
            }
          }
        }
      },
    },
  },
  methods: {
    onResize(x, y, width, height) {
      this.x = 0
      this.y = 0
      this.width = width
      this.height = height
    },
    onDrag: function (x, y) {
      this.x = x
      this.y = y
      this.firstRender = false
    },
    modalClick(key) {
      if (key === 'max') {
        this.modalMax = 1
        this.x = 1
        this.y = 1
        this.width = document.body.clientWidth
        this.height = document.body.clientHeight
      }
      if (key === 'min') {
        if (this.modalMax === 0) {
          this.minx = 1
          this.miny = 1
          console.log('min--1')
          this.$emit('closeDragBox', false)
          if (this.videoPlayer) {
            this.videoPlayer = ''
          }
          this.minWind = true
        } else {
          console.log('min--2')
          this.modalMax = 0
          this.reData()
        }
      }
      if (key === 'close') {
        this.refClose()
        console.log('close')
        this.$emit('closeDragBox', false)
        if (this.videoPlayer) {
          this.videoPlayer = ''
        }
      }
    },
    minModal(key) {
      if (key === 'max') {
        this.minWind = false
        // this.visiable = true
        this.reData()
        this.$emit('closeDragBox', true)
      }
      if (key === 'close') {
        this.refClose()
      }
    },
    reData() {
      this.width = this.defaultWidth
      this.height = this.defaultHeight
      const bodyHeight = document.body.clientHeight
      this.documentHeight = bodyHeight
      const boxTop = bodyHeight - this.height
      this.y = boxTop
      this.x = 0
    },
    refClose() {
      this.reData()
      this.minWind = false
      this.modalMax = 0
    },
    listenResize() {
      if (this.firstRender) {
        const bodyHeight = document.body.clientHeight
        this.documentHeight = bodyHeight
        const boxTop = bodyHeight - this.height
        this.y = boxTop
        this.x = 0
      }
    },
    changeTab(key) {
      this.activeKey = key
      const type = key.split('_')[1]
      const id = key.split('_')[0]
      if (type === 'form') {
        this.getBgData(id)
      } else if (type === 'video') {
        if (getBgTataData(id) !== null) {
          this.videoUrl = getBgTataData(id)
        }
      }
    },
    onEdit(targetKey, action) {
      this[action](targetKey)
    },
    remove(targetKey) {
      let activeKey = this.activeKey.split('_')[0]
      const tarKey = targetKey.split('_')[0]
      const tarType = targetKey.split('_')[1]
      let lastIndex
      this.paneList.forEach((pane, i) => {
        console.log(pane)
        if (pane.id === tarKey) {
          lastIndex = i - 1
        }
      })
      const paneList = this.paneList.filter((pane) => pane.id !== tarKey)
      if (paneList.length && activeKey === tarKey) {
        if (lastIndex >= 0) {
          activeKey = paneList[lastIndex].id
        } else {
          activeKey = paneList[0].id
        }
      }
      this.paneList = paneList
      this.activeKey = `${activeKey}_${tarType}`
    },
    // 获取背景单据数据
    async getBgData(bgId) {
      this.bgDatas.length = 0
      // if (getBgTataData(bgId) !== null) {
      //   this.bgDatas = getBgTataData(bgId)
      //   // this.reloadVideo(bg);
      //   // this.bgTabDatas.push(bgId)
      //   this.reData()
      //   return
      // }
      const params = parseParam({
        bgId: bgId,
      })
      const res = await this.$http.post(`${Urls.getBgData}&${params}`)
      if (res) {
        this.bgDatas = res.data // 背景数据
        putBgTataData(bgId, res.data)
        // this.bgTabDatas.push(bgId)
        // this.bgTabIndex = this.bgTabDatas.length - 1
        this.reData()
      }
    },
  },
}
</script>
<style lang="less" scoped>
/*draggable 测试样式 */
.text-event {
  float: left;
  height: 500px;
  width: 500px;
  border: 1px solid red;
  position: relative;
}
.p-event {
  float: left;
  height: 300px;
  width: 300px;
  border: 1px solid blue;
  position: relative;
  margin-left: 20px;
}

.dragging1 {
  position: relative;
  z-index: 9999;
  border-radius: 5px;
  border: 1px solid #335774;
  background: #fff;
  padding: 4px;
  // position: fixed;
  // bottom: 1px;
  // left: 1px;
  pointer-events: auto;
}
.dragging2 {
  // position: relative;
  border-radius: 5px;
  border: 1px solid #335774;
  background: #fff;
  // padding: 4px;
  // bottom: 10px;
  border-radius: 5px;
}
</style>
<style lang="less" scoped>
/*draggable 内部窗口样式 */
.bgzl-header {
  background: #335774;
  height: 38px;
  width: 100%;
  display: -webkit-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bgzl-header .bgzl-title {
  display: -webkit-box;
  display: flex;
}
.bgzl-header .bgzl-title img {
  display: block;
  width: 20px;
  height: 20px;
}
.bgzl-header .bgzl-title .title {
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  padding-left: 10px;
}
.bgzl-header .btn-g {
  background: #335774;
  border: none;
  color: #fff;
}
.bgzl-modal-max {
  // transform: none !important;
  top: 0px !important;
  left: 0px !important;
  width: 100% !important;
  height: 100% !important;
}
.minTaskModal {
  position: absolute;
  z-index: 99999;
  box-sizing: border-box;
  bottom: 20px;
  left: 0px;
}
.taskModal {
  position: fixed;
  box-sizing: border-box;
  bottom: 1px;
  left: 1px;
  pointer-events: auto;
  z-index: 9999;
}
.boundary-div {
  position: fixed;
  top: 0;
  pointer-events: none;
  z-index: 9999;
}
.videoIframe {
  width: 100%;
  height: 310px;
}
</style>
<style lang="less">
input {
  outline: none;
  border: none;
}
.dragging1 {
  .handle {
    border-color: #335774;
    background: #335774;
  }

  .handle-tm {
    left: 10px;
    top: 0;
    width: calc(100% - 20px);
    margin-left: 0;
    height: 4px;
  }

  .handle-tl {
    top: 0;
    left: 0;
    width: 10px;
    height: 10px;
    border-right: none;
    border-bottom: none;
    border-width: 4px;
  }

  .handle-tr {
    top: 0px;
    right: 0px;
    width: 10px;
    height: 10px;
    border-left: none;
    border-bottom: none;
    border-width: 4px;
  }

  .handle-mr {
    top: 0;
    margin-top: 10px;
    right: 0;
    height: calc(100% - 20px);
    width: 4px;
  }

  .handle-br {
    bottom: 0;
    right: 0;
    width: 10px;
    height: 10px;
    border-left: none;
    border-top: none;
    border-width: 4px;
  }

  .handle-bm {
    bottom: 0;
    left: 10px;
    margin-left: 0;
    width: calc(100% - 20px);
    height: 4px;
  }

  .handle-bl {
    bottom: 0;
    left: 0;
    width: 10px;
    height: 10px;
    border-top: none;
    border-right: none;
    border-width: 4px;
  }

  .handle-ml {
    top: 0;
    margin-top: 10px;
    left: 0;
    height: calc(100% - 20px);
    width: 4px;
  }
}
</style>
